import React from 'react';
import { ASSETS_FOLDER } from '../../../constants';
import * as Features from '../../../utils/Features';
import './BackButton.css';
import { ALT } from '../../../texts';

const BackButton = props => (
  <button
    className={`back-button ${Features.features.mobile ? 'mobile' : 'desktop'}`}
    onClick={props.onClick}
  >
    <img src={`${ASSETS_FOLDER}img/ico/back.png`} alt={ALT.BACK} />
  </button>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/Shared/BackButton/BackButton.js